import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { alertActions, contracterActions } from '../../store/actions'
import Input from '../input'
import moment from 'moment'
import { commons } from '../../hook/common'
import Calendar from '../component-box/Calendar'

/**
 * 세금계산서 등록/수정 팝업
 * @param props
 * @constructor
 */
const PopupAddTax = (props) => {
  const nodeBaseInfo = {
    taxNo: {
      title: '세금계산서 번호',
      type: 'text',
      length: 11,
      required: true,
      message: '세금계산서번호를 입력해주세요.',
    },
    itemCd: {
      title: '제품코드',
      type: 'text',
      length: 20,
    },
    itemnm: {
      title: '품명',
      type: 'text',
      length: 200,
    },
    itemdeftxt: {
      title: '규격',
      type: 'text',
      length: 100,
    },
    splyAmt: {
      title: '공급가액',
      type: 'number',
      required: true,
      message: '공급가액을 입력해주세요.',
    },
    taxAmt: {
      title: '세액',
      type: 'number',
      required: true,
      message: '세액을 입력해주세요.',
    },
    itemqty: {
      title: '수량',
      type: 'number',
    },
    itemqtyunitcd: {
      title: '수량코드',
      type: 'text',
    },
    writedt: {
      title: '작성일자',
    },
  }

  const inputRef = React.useRef(new Array(Object.keys(nodeBaseInfo).length))
  const [state, setState] = useState({})
  const [nodeInfo, setNodeInfo] = useState(nodeBaseInfo)
  const [reset, setReset] = useState(false)
  const [isEdit, setIsEdit] = useState(false)
  const [editIdx, setEditIdx] = useState(false)
  const [itemList, setItemList] = useState(props.stepData)
  const [itemInput, setItemInput] = useState({})
  const [selectItems, setSelectItems] = useState([])

  /**
   * 화면집입시 초기값 세팅
   */
  useEffect(() => {
    let list = JSON.parse(sessionStorage.getItem(props.docid)).step4

    setItemList(list)
    setItemInput({ seq: list.length + 1 })
    commons.preventKeyDown()
  }, [])

  /**
   * 데이터 저장 후 입력폼 갱신
   */
  useEffect(() => {
    if (props.isCalled === true) {
      setItemList(props?.stepData)
      newInput()
      setReset(true)
    }
    props.setCalled(false)
  }, [props?.isCalled])

  /**
   * input 갱신을 위한 hook
   */
  useEffect(() => {
    if (reset === true) setReset(false)
  }, [reset])

  /**
   * 물품목록 선택팝업 콜백
   */
  useEffect(() => {
    let list = JSON.parse(sessionStorage.getItem(props.docid)).step2
    let item = list?.filter((item) => {
      return item.crtItemSeq === props.selectItemSeq
    })[0]

    item &&
      setItemInput({
        ...itemInput,
        hsCd: item?.hsCd,
        itemnm: item?.itemnm,
        itemdeftxt: item?.itemdeftxt,
      })
  }, [props.selectItemSeq])

  /**
   * 입력학목 유효성 체크 및 저장 api 호출
   */
  const saveItem = () => {
    setState({ ...state, submitted: !state.submitted, errWritedt: '' })

    let node = nodeInfo
    let errCnt = 0
    let isFocus = false

    Object.keys(node).forEach((key, index) => {
      let message = null

      //필수 체크
      if (node[key].required) {
        if (!itemInput?.[key] || itemInput?.[key]?.length <= 0) {
          message = node[key]?.message
          errCnt++
        }
      }

      node[key].errMessage = message

      if (!isFocus && errCnt === 1) {
        isFocus = true
        console.log(index)
        inputRef.current[index].focus()
      }
    })

    if (!itemInput.writedt || itemInput.writedt?.length <= 0) {
      setState({ ...state, errWritedt: '작성일자를 선택해주세요.' })
      errCnt++
    }

    if (errCnt > 0) return

    props.saveStep(props.docid, '4', itemInput, isEdit)
  }

  /**
   * 물품정보 수정
   * @param seq
   */
  const selectEdit = (crtTaxSeq, index = -1) => {
    if (editIdx === index) {
      newInput()
    } else {
      setItemInput({ ...itemList[itemList.findIndex((item) => item.crtTaxSeq === crtTaxSeq)] })
      setIsEdit(true)
      setEditIdx(index)
    }
  }

  /**
   * 새로작성
   */
  const newInput = () => {
    setState({ ...state, errWritedt: '' })
    let node = nodeInfo
    Object.keys(node).forEach((key, index) => {
      node[key].errMessage = null
    })

    setSelectItems([])
    setItemInput({})
    setIsEdit(false)
    setEditIdx(-1)
    setReset(true)
  }

  /**
   * 선택삭제
   * @returns {*}
   */
  const deleteItems = () => {
    if (selectItems?.length <= 0) {
      return props.error({ message: '삭제할 물품을 선택해주세요.' })
    }

    props.confirm({
      title: '확인',
      message: '정말 삭제하시겠습니까?',
      params: {
        type: 'confirm',
        callback: () => {
          props.deleteStepItems(props.docid, '4', selectItems)
        },
      },
    })
  }

  /**
   * 전체삭제
   */
  const deleteAll = () => {
    itemList?.length > 0 &&
      props.confirm({
        title: '확인',
        message: '정말 삭제하시겠습니까?',
        params: {
          type: 'confirm',
          callback: () => {
            props.deleteStepItemAll(props.docid, '4')
          },
        },
      })
  }

  const handleClose = () => {
    props.onClose()
  }

  const handleChange = (e) => {
    const { name, value } = e.target
    setItemInput({
      ...itemInput,
      [name]: value,
    })
  }

  const onSelectItem = (e) => {
    const { name, checked } = e.target
    let list = selectItems
    if (checked) {
      list.push(name)
    } else {
      list = selectItems.filter((item) => item !== name)
    }
    setSelectItems(list)
  }

  const generateInput = (key) => {
    const node = nodeInfo[key]
    let idx = Object.keys(nodeBaseInfo).findIndex((objKey) => objKey === key)
    let className = 'form-control input-text '
    let wrapperClassName = node?.wrapperClassName
    let maxLength = node.length
    !maxLength && node?.type === 'number' && (maxLength = 16)
    node?.readOnly === true && (className += 'disabled ')

    return (
      <Input
        id={key}
        name={key}
        type={node.type}
        inputTitle={node?.inputTitle ? node?.inputTitle : node?.title}
        value={itemInput?.[key] || ''}
        ref={(ref) => (inputRef.current[idx] = ref)}
        wrapperClassName={wrapperClassName}
        className={className + node?.className}
        placeholder={node?.placeholder}
        message={node?.message}
        onChange={handleChange}
        readOnly={node.readOnly}
        required={node.required}
        flow={node.flow ? node.flow : `${window.innerWidth >= 767 ? 'left' : 'up'}`}
        length={maxLength}
        errMessage={node.errMessage}
      />
    )
  }

  return (
    <React.Fragment>
      <div className="modal-overlay normal modal-certificate">
        <div className="modal modal-Full">
          <div className="modal-content">
            <div className="modal-header flex-sb">
              <div className="modal-title dis-flex">세금계산서 정보</div>
              <button type="button" className="icon-close" data-dismiss="modal" aria-label="Close" onClick={handleClose}>
                <span aria-hidden="true">&times;</span>
              </button>
            </div>

            <div className="modal-body">
              <div className="lineBox">
                <ul className="step-detail">
                  <li className="flex-l m-b-10">
                    <h4 className="title">
                      세금계산서 번호 <span className="required">*</span>
                    </h4>
                    {generateInput('taxNo')}
                  </li>
                  <li className="flex-l m-b-10">
                    <h4 className="title">제품코드</h4>
                    {generateInput('itemCd')}
                  </li>
                  <li className="m-b-10">
                    <div className="flex-l">
                      <h4 className="title">구매물품 목록 선택</h4>
                      <button className="btn btn-blue" onClick={() => props.isShowItems(true)}>
                        선택
                      </button>
                    </div>
                    <p className="des">("구매물품 목록" 에서 입력한 제품을 선택)</p>
                  </li>
                  <li className="flex-l m-b-10">
                    <h4 className="title">품명</h4>
                    {generateInput('itemnm')}
                  </li>
                  <li className="flex-l m-b-10">
                    <h4 className="title">규격</h4>
                    {generateInput('itemdeftxt')}
                  </li>
                  <li className="flex-l m-b-10">
                    <h4 className="title">
                      공급가액 <span className="required">*</span>
                    </h4>
                    {generateInput('splyAmt')}
                  </li>
                  <li className="flex-l m-b-10">
                    <h4 className="title">
                      세액 <span className="required">*</span>
                    </h4>
                    {generateInput('taxAmt')}
                  </li>
                  <li className="flex-l m-b-10 type-form-sel">
                    <h4 className="title">수량</h4>
                    {generateInput('itemqty')}
                    <div className="select-wrap W-10">
                      <select
                        id="itemqtyunitcd"
                        name="itemqtyunitcd"
                        title={'수량코드'}
                        value={itemInput.itemqtyunitcd || ''}
                        onChange={handleChange}
                      >
                        <option value="">수량코드</option>
                        <option value="EA">EA</option>
                        <option value="PC">PC</option>
                        <option value="KG">KG</option>
                        <option value="CT">CT</option>
                        <option value="YD">YD</option>
                        <option value="M">M</option>
                        <option value="SET">SET</option>
                        <option value="MT">MT</option>
                        <option value="BOX">BOX</option>
                        <option value="RO">RO</option>
                        <option value="UN">UN</option>
                        <option value="PR">PR</option>
                        <option value="SF">SF</option>
                        <option value="M2">M2</option>
                        <option value="LO">LO</option>
                      </select>
                    </div>
                  </li>
                  <li className="flex-l">
                    <h4 className="title">
                      작성일자 <span className="required">*</span>
                    </h4>
                    <div className="input-wrapper ">
                      {reset === false && (
                        <Calendar
                          default={itemInput.writedt && moment(itemInput.writedt, 'YYYYMMDD').format('YYYY-MM-DD')}
                          onSelect={(value) =>
                            setItemInput({
                              ...itemInput,
                              writedt: moment(value).format('YYYYMMDD'),
                            })
                          }
                        />
                      )}
                      {state.errWritedt && <div className={'input-error'}>{state.errWritedt}</div>}
                    </div>
                  </li>
                </ul>
              </div>
              <div className="title-btn m-t-20">
                <div className="dis-flex ">
                  <span className="totalPage w-50">총 {itemList?.length}건</span>
                  <div className="flex-r w-50">
                    <button className="btn btn-white" onClick={newInput}>
                      새로작성
                    </button>
                    <button className="btn btn-white" onClick={saveItem}>
                      {isEdit === true ? '수정' : '저장'}
                    </button>
                    <button className="btn btn-white" onClick={deleteItems}>
                      선택삭제
                    </button>
                    <button className="btn btn-white" onClick={deleteAll}>
                      전체삭제
                    </button>
                  </div>
                </div>
              </div>
              <div className="table">
                <div className="row header border">
                  <div className="cell w-7">선택</div>
                  <div className="cell w-10">세금계산서 번호</div>
                  <div className="cell w-10">품명</div>
                  <div className="cell w-10">규격</div>
                  <div className="cell w-10">공금가액</div>
                  <div className="cell w-10">세액</div>
                  <div className="cell w-7">수량</div>
                  <div className="cell w-7">선적기일</div>
                </div>
                {itemList?.length > 0 ? (
                  itemList?.map((item, index) => {
                    return (
                      <div className={'row ' + (isEdit && editIdx === index ? 'active' : '')} key={index}>
                        <div className="cell">
                          <input type="checkbox" title={'checkbox' + index} name={item.crtTaxSeq} onChange={onSelectItem} />
                        </div>
                        <div className="cell" data-title={'세금계산서번호'} onClick={() => selectEdit(item.crtTaxSeq, index)}>
                          {item.taxNo}
                        </div>
                        <div className="cell" data-title={'품명'} onClick={() => selectEdit(item.crtTaxSeq, index)}>
                          {item.itemnm}
                        </div>
                        <div className="cell" data-title={'규격'} onClick={() => selectEdit(item.crtTaxSeq, index)}>
                          {item.itemdeftxt}
                        </div>
                        <div className="cell" data-title={'공급가액'} onClick={() => selectEdit(item.crtTaxSeq, index)}>
                          {commons.addComma(item.splyAmt)}
                        </div>
                        <div className="cell" data-title={'세액'} onClick={() => selectEdit(item.crtTaxSeq, index)}>
                          {commons.addComma(item.taxAmt)}
                        </div>
                        <div className="cell" data-title={'수량'}>
                          {item?.itemqty && commons.addComma(item.itemqty)} {item?.itemqtyunitcd}
                        </div>
                        <div className="cell" data-title={'작성일자'}>
                          {moment(item.writedt).format('Y-M-D')}
                        </div>
                      </div>
                    )
                  })
                ) : (
                  <div className="row noData">
                    <div className="cell">등록된 자료가 없습니다.</div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  )
}

const mapStateToProps = (state) => {
  return {
    stepData: state.contracter?.data?.step4,
    isCalled: state.contracter.isCalled,
    selectItemSeq: state.contracter.itemSeq,
  }
}

const actionCreators = {
  saveStep: contracterActions.saveStep,
  setCalled: contracterActions.setCalled,
  error: alertActions.error,
  confirm: alertActions.confirm,
  deleteStepItems: contracterActions.deleteStepItems,
  deleteStepItemAll: contracterActions.deleteStepItemAll,
  isShowItems: contracterActions.isShowItems,
}

export default connect(mapStateToProps, actionCreators)(PopupAddTax)
